require('jquery-validation');
require('jquery-validation/dist/additional-methods');
require('jquery-validation/dist/localization/messages_pt_BR');

$(document).ready(function () {
    $('form').each(function () {
        $(this).validate();
    });
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-validate.js